import {
  endOfQuarter,
  format,
  startOfQuarter,
  subDays,
  subQuarters,
} from "date-fns";

export const INVALID_CUSTOM_RANGE = "End date must be on or after start date";

export const isCustomRangeInvalid = (range, from, to) =>
  range === "custom" && from && to && from > to;

export const ALL_TIME_LABEL = "All Time";

export const RANGE_OPTIONS = [
  { value: "last7", label: "Last 7 Days" },
  { value: "last30", label: "Last 30 Days" },
  { value: "cq", label: "Current Quarter" },
  { value: "lq", label: "Last Quarter" },
  { value: "all", label: ALL_TIME_LABEL },
  { value: "custom", label: "Custom" },
];

const ALL_TIME_START = "2000-01-01";
const ISO_FORMAT = "yyyy-MM-dd";

const toIso = (date) => format(date, ISO_FORMAT);

export const resolvePeriod = (
  { range, from, to } = {},
  referenceDate = new Date()
) => {
  const end = referenceDate;
  switch (range) {
    case "last7":
      return { periodStart: toIso(subDays(end, 7)), periodEnd: toIso(end) };
    case "last30":
      return { periodStart: toIso(subDays(end, 30)), periodEnd: toIso(end) };
    case "cq":
      return { periodStart: toIso(startOfQuarter(end)), periodEnd: toIso(end) };
    case "lq": {
      const lastQuarter = subQuarters(end, 1);
      return {
        periodStart: toIso(startOfQuarter(lastQuarter)),
        periodEnd: toIso(endOfQuarter(lastQuarter)),
      };
    }
    case "all":
      return { periodStart: ALL_TIME_START, periodEnd: toIso(end) };
    case "custom":
      return { periodStart: from, periodEnd: to };
    default:
      return { periodStart: toIso(subDays(end, 30)), periodEnd: toIso(end) };
  }
};
